import { CustomizedProductVM } from "app/shared/models/customization-request.models";

export class PlayerCustomizationDTO {
  public id?: number;
  public displayName?: string;
  public firstName?: string;
  public lastName?: string;
  public number?: string;

  constructor(init?: PlayerCustomizationDTO) {
    Object.assign(this, init);
  }
}

export class PlayerCustomizationInfoGridRowVM {
  public styleCode: string;
  public productComments: string;
  public sizeName: string;
  public sizeId?: number;
  public sizeOrder: number;
  public noCustomQty: number;
  public customQty: number;
  public numbers: string;
  public shirtNames: string;
  
  constructor(init?: PlayerCustomizationInfoGridRowVM) {
    Object.assign(this, init);
  }
}

export class PlayerInfoGridRowVM {
  public id?: number;
  public styleCode: string;
  public productComments: string;
  public sizeName: string;
  public sizeId?: number;
  public sizeOrder: number;
  public quantity: number;
  public numbers?: string;
  public shirtNames?: string;
  
  constructor(init?: PlayerInfoGridRowVM) {
    Object.assign(this, init);
  }
}

export class PlayerCustomizationVM extends PlayerCustomizationDTO {
  public products?: CustomizedProductVM[];
  public productsSizesCount?: number;
  public productsSizes?: PlayerCustomizationProductSize[];

  isReady?: boolean;
  constructor(init?: PlayerCustomizationVM) {
    super();
    Object.assign(this, init);
  }
}

export class PlayerCustomizationProductSize {
  public productId: number;
  public productCode: string;
  public productName: string;
  public sizeId: number;
  public sizeName: string;
  constructor(init?: PlayerCustomizationProductSize) {
    Object.assign(this, init);
  }
}